import { FacebookPageDto, ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { put, takeLeading } from 'redux-saga/effects';

import FacebookPage from '@/models/interfaces/FacebookPage';

import { fromDto as fromFacebookPageDto } from '../../../../models/adapters/FacebookPageAdapter';
import {
  facebookPagesFetched,
  facebookPagesFetchFailed,
  FacebookPagesFetchResponsePayload,
  fetchFacebookPages,
  FetchFacebookPagesPayload,
} from '../../../actions/setting/facebook/fetchFacebookPages';
import getAuthenticationToken from '../../getAuthenticationToken';
import getProtectedResponse from '../../getProtectedResponse';

function createFacebookPagesFetchResponseAction(
  response: { facebookPages: FacebookPageDto[]; error: string },
  placeUuid: string
): Action<FacebookPagesFetchResponsePayload> {
  const { facebookPages: facebookPageDtos, error } = response;
  const timestamp = moment();
  if (!error && facebookPageDtos) {
    const facebookPages = facebookPageDtos
      .map((facebookPage) => fromFacebookPageDto(facebookPage))
      .filter((facebookPage): facebookPage is FacebookPage => !!facebookPage);
    return facebookPagesFetched({
      facebookPages,
      placeUuid,
      timestamp,
    });
  }
  return facebookPagesFetchFailed({ facebookPages: [], placeUuid, timestamp });
}

function* fetchFacebookPagesSaga({ payload }: Action<FetchFacebookPagesPayload>) {
  const token = yield getAuthenticationToken();
  const { placeUuid, accessToken } = payload;
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getFacebookPages, token, {
    accessToken,
    placeUuid,
  });
  const action = createFacebookPagesFetchResponseAction(response, placeUuid);
  yield put(action);
}

export default function* watchFetchFacebookPagesSaga() {
  yield takeLeading(fetchFacebookPages, fetchFacebookPagesSaga);
}
